import { render, staticRenderFns } from "./MasonryItem.vue?vue&type=template&id=4407658c&scoped=true&"
import script from "./MasonryItem.vue?vue&type=script&lang=js&"
export * from "./MasonryItem.vue?vue&type=script&lang=js&"
import style0 from "./MasonryItem.vue?vue&type=style&index=0&id=4407658c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4407658c",
  null
  
)

export default component.exports